import { lazy, useCallback } from 'react'

import { useModal } from '../../Modal/Provider.js'

const SalesforceFormModal = lazy(() =>
  import('../SalesforceFormModal.js').then(m => ({
    default: m.SalesforceFormModal,
  })),
)

export const useContactUs = () => {
  const { openModal } = useModal()
  const openContactUs = useCallback(
    ({
      subject = '',
      type = '',
      description = '',
      hasVisualProof = false,
      hasSupportAccess = false,
    }) => {
      openModal({
        name: 'contactUs',
        component: SalesforceFormModal,
        props: {
          type,
          subject,
          description,
          hasVisualProof,
          hasSupportAccess,
        },
      })
    },
    [openModal],
  )

  return {
    openContactUs,
  }
}
